/**
 * 企画連絡承認画面Input用VOクラス
 *
 * @export KYMW1317InputModel
 * @class KYMW1317InputModel
 */
export class KYMW1317InputModel {

  // 受注コード
  public orderCode: string = <string>'';
  // Ｐコード
  public pCodeList: Array<any> = new Array<any>();
  // 媒体区分
  public MediumType: string = <string>'';
  // ユーザ権限
  public UserPermission: string = <string>'';
  // ロック情報
  public lockInfo: string = <string>'';
}
